/**
 * Puente entre el interceptor de axios (que no puede usar hooks) y el árbol
 * de React (dueño de notistack). Espejo de `scopeErrorBridge.js`.
 *
 * El interceptor de `apiClient.js` llama `emitPaywall(detail)` cuando el
 * backend responde 402 con `{ error: "paywall", reason, feature, action }`.
 * `PaywallSnackbarHandler` se suscribe con `onPaywall`.
 */

const listeners = new Set();

export const emitPaywall = (detail) => {
  listeners.forEach((fn) => {
    try {
      fn(detail);
    } catch (err) {
      // Un listener roto nunca debe tumbar la cadena del interceptor
      // eslint-disable-next-line no-console
      console.error('paywall listener failed:', err);
    }
  });
};

export const onPaywall = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
